import { Component, ComponentInterface, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-table-cell',
  styleUrl: 'signet-table.scss',
  shadow: false,
  scoped: false,
})
export class SignetTableCell implements ComponentInterface {
  @Prop() align: 'right' | 'left' = 'left';

  render() {
    const classes = {
      'signet-table-cell': true,
      'align-right': this.align === 'right',
      'align-left': this.align === 'left',
    };

    return (
      <p class={classes}>
        <slot></slot>
      </p>
    );
  }
}
